module.exports = __webpack_public_path__ + "img/goodness-23.c6ca6db3.png";